import styled from "styled-components";

export const HeaderComponent = styled.div`
	font-size: 18px;
	font-weight: bold;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.5rem;
	margin-bottom: 18px;
	color: #2d3748;
	font-family: "Roboto", "Roboto-Medium" !important;
`;

export const ActionButtonComponent = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background-color: #e4e7ed;
    height: 69px;
`;

export const StatusCell = styled.div<{ $isVisible: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({ $isVisible }) =>
		$isVisible ? "#ffeaea" : "#eaffef"};
	color: ${({ $isVisible }) => ($isVisible ? "#c94040" : "#40c965")};
	width: 103px;
	height: 24px;
	font-weight: normal;
	font-family: "Roboto";
`;

export const Container = styled.div`
	background-color: white;
`;

export const ContainerHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: 69px;
	background-color: #e4e7ed;
	padding: 1.25rem;
`;